(function () {
  var wrap = document.querySelector('.price-tiers');
  if (!wrap) return;
  var grid = wrap.querySelector('.price-tiers__grid');
  if (!grid) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var initialized = false;
  var raf = null;
  var jumpLock = false;
  var hintHidden = false;

  function tiers() {
    return grid.querySelectorAll('.price-tier');
  }

  function step() {
    var t = tiers();
    if (t.length < 2) return 0;
    return t[1].getBoundingClientRect().left - t[0].getBoundingClientRect().left;
  }

  function setupClones() {
    grid.querySelectorAll('.price-tier--clone').forEach(function (e) {
      e.remove();
    });
    var originals = Array.prototype.slice.call(grid.querySelectorAll('.price-tier'));
    if (!originals.length) return 0;
    originals.forEach(function (o) {
      var c = o.cloneNode(true);
      c.classList.add('price-tier--clone');
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      grid.appendChild(c);
    });
    originals.slice().reverse().forEach(function (o) {
      var c = o.cloneNode(true);
      c.classList.add('price-tier--clone');
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      grid.insertBefore(c, grid.firstChild);
    });
    return originals.length;
  }

  function highlight() {
    raf = null;
    var t = tiers();
    if (!t.length) return null;

    var gr = grid.getBoundingClientRect();
    var cx = gr.left + gr.width / 2;
    var active = null;
    var best = Infinity;
    t.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - cx);
      if (d < best) {
        best = d;
        active = el;
      }
    });
    t.forEach(function (el) {
      el.classList.toggle('is-snapped', el === active);
    });
    return active;
  }

  function maybeWrap() {
    if (jumpLock) return;
    var t = tiers();
    if (!t.length) return;
    var setSize = t.length / 3;
    if (setSize !== Math.floor(setSize)) return;

    var active = null;
    var best = Infinity;
    var gr = grid.getBoundingClientRect();
    var cx = gr.left + gr.width / 2;
    t.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - cx);
      if (d < best) {
        best = d;
        active = el;
      }
    });
    if (!active) return;

    var idx = Array.prototype.indexOf.call(t, active);
    if (idx >= setSize && idx < setSize * 2) return;

    var dir = idx < setSize ? 1 : -1;
    var dist = step() * setSize * dir;
    if (!dist) return;

    jumpLock = true;
    var prevBehavior = grid.style.scrollBehavior;
    grid.style.scrollBehavior = 'auto';
    grid.scrollLeft += dist;
    requestAnimationFrame(function () {
      grid.style.scrollBehavior = prevBehavior || '';
      highlight();
      jumpLock = false;
    });
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(highlight);
  }

  var settleTimer = null;
  function scheduleSettle() {
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      settleTimer = null;
      maybeWrap();
    }, 140);
  }

  function centerFeatured() {
    var t = tiers();
    var setSize = t.length / 3;
    if (!setSize || setSize !== Math.floor(setSize)) return;
    for (var i = setSize; i < setSize * 2; i++) {
      if (t[i].classList.contains('price-tier--featured')) {
        var r = t[i].getBoundingClientRect();
        var gr = grid.getBoundingClientRect();
        var prevBehavior = grid.style.scrollBehavior;
        grid.style.scrollBehavior = 'auto';
        grid.scrollLeft += r.left + r.width / 2 - (gr.left + gr.width / 2);
        requestAnimationFrame(function () {
          grid.style.scrollBehavior = prevBehavior || '';
          highlight();
        });
        return;
      }
    }
  }

  function hideHint() {
    if (hintHidden) return;
    wrap.classList.add('is-swiped');
    hintHidden = true;
  }

  function teardown() {
    grid.querySelectorAll('.price-tier--clone').forEach(function (e) {
      e.remove();
    });
    tiers().forEach(function (el) {
      el.classList.remove('is-snapped');
    });
    initialized = false;
  }

  function activate() {
    if (mq.matches) {
      if (!initialized) {
        setupClones();
        grid.addEventListener(
          'scroll',
          function () {
            schedule();
            scheduleSettle();
          },
          { passive: true }
        );
        if ('onscrollend' in window) {
          grid.addEventListener('scrollend', function () {
            if (!jumpLock) maybeWrap();
          });
        }
        grid.addEventListener('touchstart', hideHint, { passive: true });
        grid.addEventListener('pointerdown', hideHint, { passive: true });
        grid.addEventListener('wheel', hideHint, { passive: true });
        initialized = true;
      }
      requestAnimationFrame(function () {
        centerFeatured();
        highlight();
      });
    } else {
      teardown();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate);
  } else {
    activate();
  }
  if (mq.addEventListener) mq.addEventListener('change', activate);
  else if (mq.addListener) mq.addListener(activate);
  window.addEventListener('resize', function () {
    if (mq.matches && initialized) schedule();
    else activate();
  });
})();
